import { Link } from "react-router-dom";

export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
    <circle cx="16" cy="16" r="10.5" stroke="#38BDF8" strokeWidth="1.5" />
    <path d="M16 2.5v4M16 25.5v4M2.5 16h4M25.5 16h4" stroke="#38BDF8" strokeWidth="1.5" />
    <path d="M9.5 22.5L22.5 9.5" stroke="#F59E0B" strokeWidth="1.8" />
    <circle cx="16" cy="16" r="2" fill="#F59E0B" />
  </svg>
);

export default function Logo() {
  return (
    <Link to="/" data-testid="brand-logo-link" className="flex items-center gap-3">
      <LogoMark />
      <span className="flex flex-col leading-none">
        <span className="font-display text-sm font-bold tracking-[0.14em] text-slate-100">
          GLOBAL DIMENSIONS, INC.
        </span>
        <span className="mt-1.5 font-mono text-[9px] tracking-[0.3em] text-cad/90">
          AS-BUILT SURVEY · 3D SCAN
        </span>
      </span>
    </Link>
  );
}
